module.exports = __webpack_public_path__ + "static/img/ban01.4cc2170.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/ban01.jpg
// module id = lC75
// module chunks = 1